import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { func, bool, shape, string } from 'prop-types'
import { getQueryParameter } from 'services/utils/strings'
// actions
import * as loginActions from 'services/app-state/login/actions'
import * as userActions from 'services/app-state/user/actions'
import * as decryptEmailActions from 'services/app-state/decrypt-email/actions'
import * as resetPasswordActions from 'services/app-state/reset-password/actions'

import { PAGE_PREFIX } from 'services/utils/constants/validations'
import { trackSignalEvent } from 'services/utils/analytics'

// components
import { Loader } from 'components'
import LoginForm from './components/login-form'
import WelcomeMsg from './components/welcome-msg'
import LoginThirdParty from './components/login-third-party'
import RenderBottomSection from './components/bottom-content'

class LoginContainer extends Component {
  componentDidMount() {
    const { userActions: { fetchLoginInfo }, ui: { isThirdParty } } = this.props
    const receivedEmail = getQueryParameter('email', window.location.href, true)
    const isSignInRedirect = getQueryParameter('referrer') === 'signin_btn' // To identify redirects from sign in button click
    const loginData = {
      isThirdPartyLogin: isThirdParty,
      pageName: `${PAGE_PREFIX}Login Page`,
    }
    if (!receivedEmail && !isSignInRedirect) {
      fetchLoginInfo(() => {
        trackSignalEvent('triggerOmniture', loginData)
      })
    } else {
      trackSignalEvent('triggerOmniture', loginData)
    }
  }
  render() {
    const { login: { isPerimeterXEnabled }, user: { isUserActive }, ui } = this.props
    const {
      isThirdParty,
      isFetching,
      isChatBotUser,
    } = ui

    if (isFetching) return <Loader />

    return (
      <div className="container-wrapper">
        <div className="main-container login">
          <div className="login-container">
            <WelcomeMsg {...this.props} />
            {isUserActive && isThirdParty ? (
              <LoginThirdParty {...this.props} />
              ) : (
                <LoginForm
                  {...this.props}
                />
              )}
            {isUserActive || isPerimeterXEnabled || isChatBotUser ? null : (
              <RenderBottomSection {...this.props.ui} />
              )}
          </div>
        </div>
      </div>
    )
  }
}

LoginContainer.propTypes = {
  userActions: shape({
    fetchLoginInfo: func,
  }),
  resetPasswordActions: shape({
    submitResetForm: func,
  }),
  ui: shape({
    isThirdParty: bool,
    isFetching: bool,
    isChatBotUser: bool,
    isCreditCardUser: bool,
  }),
  login: shape({
    isPerimeterXEnabled: bool,
  }).isRequired,
  user: shape({
    isUserActive: bool,
  }),
  resetPassword: shape({
    step: string,
  }),
}

LoginContainer.defaultProps = {
  userActions: {
    fetchLoginInfo: () => {},
  },
  resetPasswordActions: {
    submitResetForm: () => {},
  },
  ui: {
    isThirdParty: false,
    isCreditCardUser: false,
  },
  user: {
    isUserActive: true,
  },
  resetPassword: {
    step: '',
  },
}

const mapStateToProps = ({
  ui, app: {
    login, user, decryptEmail, resetPassword,
  },
}) => ({
  login,
  user,
  ui,
  decryptEmail,
  resetPassword,
})

const mapDispatchToProps = dispatch => ({
  loginActions: bindActionCreators(loginActions, dispatch),
  decryptEmailActions: bindActionCreators(decryptEmailActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch),
  resetPasswordActions: bindActionCreators(resetPasswordActions, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer)
